require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/number/is-integer.js
 ** module id = 910
 ** module chunks = 0
 **/